import React, { useMemo } from "react";

import { Agent } from "../../../../../../../../../../services";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

const GroupCellContent: React.FC<GroupCellContent.Props> = ({ item }) => {
	const content = useMemo(
		() => item.agentGroup?.name ?? "",
		[item.agentGroup?.name],
	);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace GroupCellContent {
	interface Props {
		item: Agent.Model;
	}
}

export default GroupCellContent;
